import { render, staticRenderFns } from "./RupturasContainer.vue?vue&type=template&id=6d7df6d4&scoped=true"
import script from "./RupturasContainer.vue?vue&type=script&lang=js"
export * from "./RupturasContainer.vue?vue&type=script&lang=js"
import style0 from "./RupturasContainer.vue?vue&type=style&index=0&id=6d7df6d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7df6d4",
  null
  
)

export default component.exports